// extracted by mini-css-extract-plugin
export default {"container":"Hp-z","brandName":"Ip-z","productName":"Jp-z","productNamePdpEnhancements":"Kp-z","breakLongProductName":"Lp-z"};